import React from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridPaginationModel,
} from "@mui/x-data-grid";

interface Props {
  rows: any[];
  columns: GridColDef[];
  loading?: boolean;
  getRowId?: (row: any) => any;

  pageSizeOptions?: number[];
  initialState?: any;

  // 🔥 NEW (optional → backward compatible)
  rowCount?: number;
  paginationMode?: "client" | "server";
  paginationModel?: GridPaginationModel;
  onPaginationModelChange?: (model: GridPaginationModel) => void;
}

const DataTable: React.FC<Props> = ({
  rows,
  columns,
  loading = false,
  getRowId,

  pageSizeOptions,
  initialState,

  // 🔥 NEW
  rowCount,
  paginationMode = "client",
  paginationModel,
  onPaginationModelChange,
}) => {
  return (
    <Box className="booking-table-container">
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId || ((row) => row.id)}
        loading={loading}

        pageSizeOptions={pageSizeOptions || [10, 20, 50]}

        // 🔥 IMPORTANT (server support)
        rowCount={rowCount}
        paginationMode={paginationMode}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}

        initialState={
          initialState || {
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }
        }

        pagination
        disableRowSelectionOnClick
        className="data-grid"

        sx={{
          minWidth: 600,

          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },

          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },

          "& .MuiDataGrid-columnHeader": {
            display: "flex",
            justifyContent: "center",
          },
        }}
      />
    </Box>
  );
};

export default DataTable;